import { editableRecord, RATING_CHOICES } from './ratings';

export const RATINGS_UPLOAD_COLUMNS = ['CUSIP', 'RATING', 'TEAM', 'ANALYST'];

export function validateRatingsUpload(sheet, rows, options, baseline) {
  if (!sheet?.length) throw new Error('The workbook is empty.');
  const headers = sheet[0].map((value) => String(value ?? '').trim().toUpperCase());
  for (const field of RATINGS_UPLOAD_COLUMNS) {
    if (headers.filter((header) => header === field).length !== 1)
      throw new Error(`Include exactly one ${field} column. Use Download Editable Excel for the template.`);
  }
  if (headers.some((header) => header && !RATINGS_UPLOAD_COLUMNS.includes(header)))
    throw new Error('Use only CUSIP, RATING, TEAM and ANALYST columns.');
  const known = new Set(rows.map((row) => row.CUSIP));
  const seen = new Set();
  const errors = [];
  const records = [];
  sheet.slice(1).forEach((cells, index) => {
    if (cells.every((cell) => cell == null || String(cell).trim() === '')) return;
    const row = editableRecord(Object.fromEntries(RATINGS_UPLOAD_COLUMNS.map((field) => [
      field, String(cells[headers.indexOf(field)] ?? '').trim(),
    ])));
    const prefix = `Row ${index + 2}`;
    if (!row.CUSIP || !known.has(row.CUSIP)) errors.push(`${prefix}: CUSIP is missing or not in the loaded Latest snapshot.`);
    if (seen.has(row.CUSIP)) errors.push(`${prefix}: duplicate CUSIP ${row.CUSIP}.`);
    seen.add(row.CUSIP);
    if (!RATING_CHOICES.includes(row.RATING ?? '')) errors.push(`${prefix}: Rating must be 1–6, N/A - Paid Off, or blank.`);
    for (const field of ['TEAM', 'ANALYST']) {
      if (row[field] && row[field] !== baseline.get(row.CUSIP)?.[field] && !(options[field] || []).includes(row[field]))
        errors.push(`${prefix}: ${field} must be an active Input value or blank.`);
    }
    records.push(row);
  });
  if (errors.length) throw new Error(errors.slice(0, 20).join('\n') + (errors.length > 20 ? `\n…and ${errors.length - 20} more errors.` : ''));
  if (!records.length) throw new Error('The workbook contains no security rows.');
  return records;
}


export function sizeRatingsColumns(workbook, data) {
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  sheet['!cols'] = RATINGS_UPLOAD_COLUMNS.map((field) => ({
    wch: data.reduce((longest, row) => Math.max(
      longest, ...String(row[field] ?? '').split(/\r?\n/).map((line) => line.length)
    ), field.length) + 4,
  }));
  // The shared parser omits number formats. Restore Text after sizing so
  // editing numeric-looking ratings/CUSIPs in Excel does not convert them.
  data.forEach((row, rowIndex) => {
    RATINGS_UPLOAD_COLUMNS.forEach((field, columnIndex) => {
      const address = `${String.fromCharCode(65 + columnIndex)}${rowIndex + 2}`;
      sheet[address] = { ...sheet[address], t: 's', v: String(row[field] ?? ''), z: '@' };
    });
  });
  if (sheet['!ref']) sheet['!autofilter'] = { ref: sheet['!ref'] };
}
